const mxaFeatureProperties = Object.freeze({
  disableStrictValidation: {
    title: 'ProjectFeatures_MXA_Feature_DisableStrictValidation_Title',
    description: 'ProjectFeatures_MXA_Feature_DisableStrictValidation_Desc',
    dataQa: 'mxa-feature-disable-strict-validation'
  },
  liveEditJourneys: {
    title: 'ProjectFeatures_MXA_Feature_LiveEditJourneys_Title',
    description: 'ProjectFeatures_MXA_Feature_LiveEditJourneys_Desc',
    dataQa: 'mxa-feature-live-edit-journeys'
  }
})

export default mxaFeatureProperties



// WEBPACK FOOTER //
// ./src/modules/project/data/mxa-feature-properties.js